// Item icons drawn from the pixel rows in shared/items.ts, built once and reused.
import { itemDef } from '../../../shared/items.js';

const cache = new Map<string, HTMLCanvasElement>();

export function itemIcon(id: string): HTMLCanvasElement {
  let cv = cache.get(id);
  if (cv) return cv;
  cv = document.createElement('canvas'); cv.width = 12; cv.height = 12;
  const d = itemDef(id), c = cv.getContext('2d')!;
  if (d) d.icon.forEach((row, y) => { for (let x = 0; x < row.length; x++) { const k = row[x]; if (k !== '.' && d.colors[k]) { c.fillStyle = d.colors[k]; c.fillRect(x, y, 1, 1); } } });
  else { c.fillStyle = '#c9bda4'; c.fillRect(2, 2, 8, 8); }
  cache.set(id, cv);
  return cv;
}
